/**
 * Acceso a rutas de reporte en línea (TaskRealtime) y entradas de menú asociadas.
 *
 * Si la ruta define `featureAccessAnyOf`, el acceso exige permiso base (p. ej. tareaRead) **y**
 * al menos uno de esos feature keys cuando el contexto de tenant ya cargó. Así no basta
 * `tareaRead` para ver reportes que deben ir acotados por feature.
 *
 * Si el contexto falló al cargar, solo se exige el permiso base (degradación; el API puede
 * seguir aplicando su propia regla).
 */
export function canAccessReportRealtimeRouteForUi(
  hasBasePermission: boolean,
  featureAccessAnyOf: string[] | undefined,
  featureKeys: string[],
  tenantAccessContextLoadStatus: 'loaded' | 'failed' | null | undefined,
): boolean {
  if (!featureAccessAnyOf?.length) {
    return hasBasePermission;
  }
  if (!hasBasePermission) {
    return false;
  }
  if (tenantAccessContextLoadStatus === 'failed') {
    return true;
  }
  if (tenantAccessContextLoadStatus === 'loaded') {
    return featureAccessAnyOf.some((k) => featureKeys.includes(k));
  }
  return false;
}
